import { useEffect } from 'react';

// Runs the callback once, on mount. (Local replacement for react-use/lib/useMount.)
export default function useMount(fn: () => void) {
  useEffect(() => {
    fn();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run exactly once, on mount
  }, []);
}
